import React from "react";

import Layout from "src/components/layout/dashboard/Layout";
import Accordion from "src/components/ui/Accordion";
import ProfileCard from "src/components/cards/ProfileCardAdmin";
import ResetPasswordCard from "src/components/cards/ResetPasswordCard";
import RolesAndPermissionsTab from "src/components/cards/RolesAndPermissionsTab";
import TenantDetailsCard from "src/components/cards/TenantDetailsCard";
import PageHeader from "src/components/common/PageHeader";
import Button from "src/components/ui/Button";

import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import { LogOut } from "lucide-react";
import * as authAdminActions from "src/redux/slices/authAdminSlice";
import { useNavigate } from "react-router-dom";
import { logoutAndRedirect } from "src/utils/auth";

const SettingsPage: React.FC = () => {
  const navigate = useNavigate();

  const {
    user: { data: user },
  } = useAppSelector((state) => state.authAdmin);
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(authAdminActions.logout());
    logoutAndRedirect({ isAdmin: true, navigate });
  };

  return (
    <Layout
      type="admin"
      meta={{
        title: "Settings | Invyntra",
        description:
          "Manage and update your account settings, security preferences, and team permissions.",
        keywords: "settings, account, security, permissions, invyntra",
      }}
    >
      <div className="space-y-4">
        {/* Header */}
        <PageHeader
          title="Settings"
          breadcrumbData={[
            { label: "Home", path: "/admin/dashboard" },
            { label: "Settings", path: "/admin/settings" },
          ]}
        />

        {/* Settings Sections */}
        <div className="space-y-4">
          <Accordion title="Profile" defaultOpen={true}>
            <ProfileCard userType={"admin"} />
          </Accordion>

          {user?.role !== "admin" && (
            <Accordion title="Company Details">
              <TenantDetailsCard />
            </Accordion>
          )}

          <Accordion title="Change Password">
            <ResetPasswordCard />
          </Accordion>

          <div>
            <Button variant="primary" color="danger" onClick={handleLogout}>
              <LogOut size={16} />
              <span>Sign out</span>
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SettingsPage;
